import * as React from 'react';

const ArrowUpLeftChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="arrow-up-left-chunky_svg__eds-icon-arrow-up-left-chunky"
        viewBox="0 0 24 24"
        {...props}
    >
        <path fill="#fff" d="M6.6 7.4v6.8h-1V5.9H14v1H7.5l10.2 10.2-.7.7z" />
        <path d="M6.3 6.4l.8.8-.8-.8m-.2 0v7.3-7.3m8.4-1H5.1v9.3h2v-6l9.9 9.9 1.4-1.4-9.7-9.8h5.8v-2z" />
    </svg>
);

ArrowUpLeftChunkySvg.displayName = 'ArrowUpLeftChunkySvg';
export default ArrowUpLeftChunkySvg;
